export class MPAReview {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "requestId",
            "baseName": "requestId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "reviewerUserId",
            "baseName": "reviewerUserId",
            "type": "string",
            "format": ""
        },
        {
            "name": "reviewerEmail",
            "baseName": "reviewerEmail",
            "type": "string",
            "format": ""
        },
        {
            "name": "reviewerName",
            "baseName": "reviewerName",
            "type": "string",
            "format": ""
        },
        {
            "name": "decision",
            "baseName": "decision",
            "type": "MPADecision",
            "format": ""
        },
        {
            "name": "comment",
            "baseName": "comment",
            "type": "string",
            "format": ""
        },
        {
            "name": "reviewedAt",
            "baseName": "reviewedAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return MPAReview.attributeTypeMap;
    }
    constructor() {
    }
}
